import React from "react";

// components
import retrievePermission from "../../utils/retrievePermission";
import UserSubscriberContext from "../../context/UserSubscriberContext";
import CommonInfoTab from "../Common/CommonInfoTab";

// icons
import ViewAgendaIcon from '@mui/icons-material/ViewAgenda';
import dayjs from "dayjs";
import CommonCallBackButton from "../Common/CommonCallBackButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import BaseApi from "../../utils/BaseApi";
import DeleteIcon from "@mui/icons-material/Delete";


class PhaseCard extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            phase: this.props.phase,
            updatePermission: 0,
            destroyPermission: 0,
        };
    }

    async componentDidMount(){
        await this.retrievePermissions();
    }

    setPhase(phase){
        this.setState(
            {phase: phase}
        )
    }

    async destroy() {
        const url = `phase/${this.props.phase.id}/`;
        const api = new BaseApi();
        await api.delete(url, {});
        await this.props.callBack();
    }

    async retrievePermissions() {
        let updatePermission = await retrievePermission(
            'PhaseViewSet',
            'partial_update',
            this.context.subscriberObject
        );
        let destroyPermission = await retrievePermission(
            'PhaseViewSet',
            'destroy',
            this.context.subscriberObject
        );
        this.setState(
            {
                updatePermission: updatePermission,
                destroyPermission: destroyPermission
            }
        );
    }

    render() {
        return(
            <CommonInfoTab
                groups={
                    [
                        {
                            title: this.state.phase.title,
                            icon: <ViewAgendaIcon />,
                            edit: {
                                permission: this.state.updatePermission,
                                fields: ['title', ],
                                baseUrl: 'phase',
                                obj: this.state.phase,
                                callBack: this.setPhase.bind(this),
                                fieldUpdates: [
                                    {
                                        name: 'title',
                                        updates: [
                                            {
                                                key: 'type',
                                                value: 'input'
                                            },
                                        ]
                                    }
                                ],
                            },
                            extraComponents: this.state.destroyPermission?[
                                {
                                    component: CommonCallBackButton,
                                    componentProps: {
                                        propsObject: 'phase',
                                        propsObjectKey: 'id',
                                        phase: this.state.phase,
                                        // label: 'Удалить',
                                        icon: DeleteIcon,
                                        color: 'danger',
                                    },
                                    callBack: this.destroy.bind(this)
                                }
                            ]:null,
                            fields: [
                                {
                                    title: 'Дата начала',
                                    value:  dayjs(this.state.phase.start_date).format('DD.MM.YYYY'),
                                    xs: 12,
                                    sm: 6,
                                    md: 6,
                                    lg: 6,
                                    edit: {
                                        permission: this.state.updatePermission,
                                        fields: ['start_date', ],
                                        baseUrl: 'phase',
                                        obj: this.state.phase,
                                        callBack: this.setPhase.bind(this),
                                    },
                                },
                                {
                                    title: 'Дата окончания',
                                    value:  dayjs(this.state.phase.end_date).format('DD.MM.YYYY'),
                                    xs: 12,
                                    sm: 6,
                                    md: 6,
                                    lg: 6,
                                    edit: {
                                        permission: this.state.updatePermission,
                                        fields: ['end_date', ],
                                        baseUrl: 'phase',
                                        obj: this.state.phase,
                                        callBack: this.setPhase.bind(this),
                                    },
                                },
                                {
                                    title: 'Результат',
                                    value:  this.state.phase.result_of_work,
                                    html: true,
                                    xs: 12,
                                    sm: 12,
                                    md: 12,
                                    lg: 12,
                                    edit: {
                                        permission: this.state.updatePermission,
                                        fields: ['result_of_work', ],
                                        baseUrl: 'phase',
                                        obj: this.state.phase,
                                        callBack: this.setPhase.bind(this),
                                    },
                                },
                                {
                                    title: 'Полная цена',
                                    value:  this.state.phase.full_price,
                                    xs: 12,
                                    sm: 6,
                                    md: 6,
                                    lg: 6,
                                    edit: {
                                        permission: this.state.updatePermission,
                                        fields: ['full_price', ],
                                        baseUrl: 'phase',
                                        obj: this.state.phase,
                                        callBack: this.setPhase.bind(this),
                                    },
                                },
                                {
                                    title: 'Процент аванса',
                                    value:  this.state.phase.advance_rate,
                                    xs: 12,
                                    sm: 6,
                                    md: 6,
                                    lg: 6,
                                    edit: {
                                        permission: this.state.updatePermission,
                                        fields: ['advance_rate', ],
                                        baseUrl: 'phase',
                                        obj: this.state.phase,
                                        callBack: this.setPhase.bind(this),
                                    },
                                },
                                {
                                    title: 'Срок аванса (дней)',
                                    value:  this.state.phase.advance_payment_days,
                                    xs: 12,
                                    sm: 6,
                                    md: 6,
                                    lg: 6,
                                    edit: {
                                        permission: this.state.updatePermission,
                                        fields: ['advance_payment_days', ],
                                        baseUrl: 'phase',
                                        obj: this.state.phase,
                                        callBack: this.setPhase.bind(this),
                                    },
                                },
                                {
                                    title: 'Срок полной оплаты (дней)',
                                    value:  this.state.phase.full_payment_days,
                                    xs: 12,
                                    sm: 6,
                                    md: 6,
                                    lg: 6,
                                    edit: {
                                        permission: this.state.updatePermission,
                                        fields: ['full_payment_days', ],
                                        baseUrl: 'phase',
                                        obj: this.state.phase,
                                        callBack: this.setPhase.bind(this),
                                    },
                                },
                            ]
                        },
                    ]
                }
            />
        )
    }
}

export default PhaseCard